var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0837 6.83367C15.2774 6.64927 15.5351 6.54732 15.8025 6.54935C16.07 6.55137 16.3261 6.6572 16.517 6.84452C16.7079 7.03183 16.8186 7.28597 16.8256 7.55331C16.8327 7.82065 16.7356 8.08028 16.5549 8.27742L11.0687 15.1387C10.9743 15.2403 10.8605 15.3218 10.7339 15.3784C10.6073 15.435 10.4706 15.4655 10.332 15.4681C10.1934 15.4707 10.0557 15.4452 9.92708 15.3934C9.7985 15.3415 9.6817 15.2642 9.58366 15.1662L5.94541 11.5279C5.84409 11.4335 5.76283 11.3197 5.70646 11.1932C5.6501 11.0667 5.61979 10.9301 5.61735 10.7916C5.6149 10.6532 5.64038 10.5156 5.69224 10.3872C5.74411 10.2588 5.82131 10.1422 5.91923 10.0442C6.01716 9.94632 6.13381 9.86912 6.26221 9.81725C6.39062 9.76539 6.52816 9.73991 6.66663 9.74236C6.8051 9.7448 6.94165 9.77511 7.06815 9.83147C7.19465 9.88784 7.3085 9.9691 7.40291 10.0704L10.2822 12.9483L15.0575 6.86392C15.0661 6.85333 15.0739 6.84324 15.0837 6.83367Z",
    fill: "#02A0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiCheck);
export default __webpack_public_path__ + "static/media/bi_check.3a19ca2a504b5ed0b1a03348428c3f3b.svg";
export { ForwardRef as ReactComponent };